import type { PersonalDatasetItem } from '@dmp/api/api.types';
import { type StateCreator } from 'zustand';

export type ProcuredDatasetsState = {
  procuredDatasets: PersonalDatasetItem[];
  isFetchingProcuredDatasets: boolean;
  totalProcuredDatasetsCount: number;
  filterOptions: {
    industries: { label: string; value: string }[];
  };
  industryFilter: string[];
  procuredDatasetsPage: number;
  procuredDatasetsPageSize: number;
};

export const initialProcuredDatasetsState: ProcuredDatasetsState = {
  procuredDatasets: [],
  isFetchingProcuredDatasets: false,
  totalProcuredDatasetsCount: 0,
  filterOptions: {
    industries: [],
  },
  industryFilter: [],
  procuredDatasetsPage: 1,
  procuredDatasetsPageSize: 12,
};

export const createProcuredDatasetsSlice: StateCreator<ProcuredDatasetsState> = () => initialProcuredDatasetsState;
